// import crypto from 'crypto'

export function sign(payload: any, secretKey: string): Promise<string> {
  const enc = new TextEncoder()

  return crypto.subtle
    .importKey(
      'raw', // raw format of the key - should be Uint8Array
      enc.encode(secretKey),
      {
        // algorithm details
        name: 'HMAC',
        hash: { name: 'SHA-512' },
      },
      false, // export = false
      ['sign', 'verify'], // what this key can do
    )
    .then((key) => {
      return crypto.subtle.sign('HMAC', key, enc.encode(JSON.stringify(payload)))
    })
    .then((signature) => {
      return Array.prototype.map
        .call(new Uint8Array(signature), (x) => x.toString(16).padStart(2, '0'))
        .join('')
        .slice(0, 12)
    })
}

// stupid safari always makes problems
export function randomUUID(): string {
  const cryptoObj = window.crypto || (window as any).msCrypto // For older browsers

  const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'

  return template.replace(/[xy]/g, (char) => {
    const random =
      (cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15) >>
      (char === 'x' ? 0 : 4)
    const value = char === 'x' ? random : (random & 0x3) | 0x8
    return value.toString(16)
  })
}

if (!('randomUUID' in crypto)) {
  ;(crypto as any).randomUUID = randomUUID
}
